import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Icon, Card, Select, Table, Button, message, Spin } from "antd";
import F from "../../../../Functions";
import moment from "moment";
import { Translate } from "react-translated";
import axios from "axios";
import Pagination from "../../../../components/pagination";
// import SetupAppointment from "../../../LandingPage/parts/setup-appointment-modal";
import "../../../Dashboard/dashboard.css";
import ShowHideStats from "../show-hide-stats";
import Collapse from "../../../../Collapse";
import {
  ASC,
  DESC,
  SORT_ORDER_ASCEND,
  SORT_ORDER_DESCEND,
} from "../../../../utils/Constants";

const Option = Select.Option;
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const today = new Date();
class VirtualOnboarderDataSentBackToAgency extends Component {
  state = {
    filter_lsp: this.props.filter_lsp,
    user: this.props.user,
    bfiles: [],
    page: 1,
    total_pages: 0,
    loading: false,
    end_date: null,
    period: null,
    stats_loading: true,
    // setup_appointment_modal: false,
    statusFilters: ["Complete", "Not Complete"],
    filteredInfo: [],
    expandStats: false,
    type_of_call_selected: "FollowUp"
  };

  componentDidMount = () => {
    this.setState({
      loading: true,
    });
    axios.get("/api/calendly/sync_events").then((res) => {
      this.setState({
        loading: false,
      });
      this.loadBFiles(1);
    });
  };

  componentDidUpdate = () => {
    const { filter_lsp, internalFilterChange } = this.props;

    if (filter_lsp !== this.state.filter_lsp && !internalFilterChange) {
      this.setState(
        {
          loading: true,
          filter_lsp,
        },
        () => {
          this.loadBFiles(1);
        }
      );
    }
  };

  loadBFiles(page) {
    let { filteredInfo } = this.state;

    const { period, start_date, end_date } = this.props;

    let from = null;
    let to = null;

    if (start_date != null && end_date != null) {
      from = start_date;
      to = end_date;
    }
    if (period != null && period != "from_to") {
      const datesData = F.getServerDateByType(period);
      from = datesData.from;
      to = datesData.to;
    }

    from = `${from} 00:00:00`;
    to = `${to} 23:59:59`;

    axios.get("/api/user").then((res) => {
      const u = res.data;
      let agency_id = null;
      if (u.user_agency_assoc.length > 0) {
        agency_id = u.user_agency_assoc[0].agency_id;
      }

      // for (let i = 0; i < u.user_agency_assoc.length; i++) {
      //   agency_id = u.user_agency_assoc[i].agency_id;
      //   break;
      // }

      let filters = [
        // { name: "agency_id", op: "==", val: agency_id },
        // { name: "review", op: "==", val: "1" },
        // { name: "rs_archived", op: "is_null" },
        // { name: "is_saved_for_later", op: "==", val: "0" },
        // { name: "deleted", op: "==", val: "0" },
        // { name: "archive", op: "==", val: "0" },
        // { name: "rs_action", op: "==", val: "1" },
        {
          or: [
            {
              name: "reschedule_appointment_vo",
              op: "eq",
              val: "0",
            },
            {
              name: "reschedule_appointment_vo",
              op: "is_null",
            },
          ],
        },

        // New Filter Added
        {
          name: "agency_id",
          op: "==",
          val: agency_id,
        },
        {
          name: "vob_completed",
          op: "==",
          val: "1",
        },
        {
          name: "vob_archived",
          op: "is_null",
        },
        // {
        //   name: "onboarding_id",
        //   op: "==",
        //   val: this.props.user.id,
        // },
        {
          name: "financial_id",
          op: "is_not_null",
        },
        {
          name: "deleted",
          op: "==",
          val: "0",
        },
        {
          or: [
            {
              name: "questions",
              op: "any",
              val: {
                name: "financial_conversion_action",
                op: "==",
                val: "1",
              },
            },
            {
              name: "questions",
              op: "any",
              val: {
                name: "financial_conversion_action",
                op: "==",
                val: "2",
              },
            },
          ],
        },
        // Adding this filter for avoiding von_appointment_date` --> null value
        {
          name: "von_appointment_date",
          op: "is_not_null",
        },
      ];

      // Add Complete Filter
      if (filteredInfo.length === 1 && filteredInfo.includes("Complete")) {
        filters.push({ name: "bfile_folow_up_completed", op: "==", val: "1" });
      } else if (
        filteredInfo.length === 1 &&
        filteredInfo.includes("Not Complete")
      ) {
        // Not Complete

        // filters.push({ name: "bfile_folow_up_completed", op: "is_null" });
        // filters.push({ name: "bfile_folow_up_completed", op: "==", val: "0" });
        filters.push({
          or: [
            {
              name: "bfile_folow_up_completed",
              op: "is_null",
            },
            {
              name: "bfile_folow_up_completed",
              op: "==",
              val: "0",
            },
          ],
        });
      }

      // New Filter Added
      if (period !== "all_bfiles") {
        filters.push(
          {
            name: "vo_sent_date",
            op: ">=",
            val: from,
          },
          {
            name: "vo_sent_date",
            op: "<=",
            val: to,
          }
        );
      }

      // new add for selected agent filter
      if (typeof this.state.filter_lsp == "number") {
        filters.push({ name: "user_id", op: "==", val: this.state.filter_lsp });
      }

      // new add
      F.getDncFilter(filters, false, true);

      filters = JSON.stringify(filters);

      F.log("filters=>", filters);

      let direction = DESC;
      if ("ea_virtual_sorting_direction" in window.localStorage) {
        direction = window.localStorage.ea_virtual_sorting_direction;
      }

      const sort_by_name = JSON.stringify({
        field: "first_name",
        direction: direction,
      });

      const url =
        "/api/b_file?page=" +
        page +
        '&q={"filters":' +
        filters +
        // ',"order_by":[{"field":"rs_appointment_date","direction":"desc"}]}';
        ',"order_by":[{"field":"von_appointment_date","direction":' +
        `"${direction}"` +
        "}," +
        sort_by_name +
        "]}";
      if (u.user_type !== "AGENCY_MANAGER") {
        axios
          .get(url)
          .then((res) => {
            const page = res.data.page;
            const total_pages = res.data.total_pages;

            // F.log("Response=>", res.data);

            F.log("URL=>", url);

            this.setState({
              loading: false,
              bfiles: res.data.objects,
              page,
              total_pages,
            });
          })
          .catch((error) => {
            this.setState({
              loading: false,
            });
            F.showAndHandleServerError(error);
          });
      }
    });
  }

  filterLSP = (val) => {
    this.setState(
      {
        filter_lsp: val,
        loading: true,
      },
      () => this.loadBFiles(1)
    );
    this.props.setInternalFilterChange(true);
  };

  mark_as_complete = (bfile) => {
    axios.put(`/api/b_file/${bfile.id}`, {
      bfile_folow_up_completed: "1"
    }).then((e) => {

      axios.post("/api/bfile_notes", {
        bfile_id: bfile.id,
        note: "B File Marked as Complete - " + moment().format("MM/DD/YYYY hh:mmA"),
        user_id: this.state.user.id,
        action: "Mark as Complete"
      })

      this.loadBFiles(this.state.page)
    })
  }

  rescheduleAppointment = (bfile) => {
    const { user } = this.state
    axios
      .put(`/api/b_file/${bfile.id}`, {
        reschedule_appointment_vo: 1,
      })
      .then((response) => {
        this.props.init();
        this.props.hideModal();
      })
      .catch((error) => {
        // F.log(error);
      });
    let data = {
      // notification_message: `User is ###${bfile.first_name}   ${bfile.last_name}### is updated by bfile ${bfile.agency.name}`,
      notification_message: `Agency ${user.user_type === "EA" ? "owner" : "staff"} has forwarded the request to reschedule the appointment for ###${bfile.first_name}   ${bfile.last_name}### .`,
      severity: "low",
      dispatch_time: Math.floor(Date.now() / 1000),
      user_ids: [bfile.onboarder_id],
      bfile_id: bfile.id,
    };
    // F.log("res.data = > ", data);
    axios.post("/api/create_notification", data).then((res) => {
      // F.log("res.data = > ", res);
      message.success(F.translate(`Notification Sent Successfully`));
      this.loadBFiles(1);
      this.props.loadStats();
    });
    axios.post("/api/bfile_notes", {
      bfile_id: bfile.id,
      note: `Agency ${user.user_type === "EA" ? "owner" : "staff"} has forwarded the request to reschedule the appointment for ${bfile.first_name}   ${bfile.last_name}.`,
      user_id: bfile.user.id,
      action: "Reschedule Appointment"
    });
  };

  handleChange = (pagination, filters, sorter) => {
    this.setState({ filteredInfo: filters.status, loading: true }, () =>
      this.loadBFiles(1)
    );
  };

  clearFilters = () => {
    this.setState({ filteredInfo: [] });
  };

  updateExpandState = () => {
    this.setState((prevState) => ({ expandStats: !prevState.expandStats }));
  };

  render() {
    const { user } = this.props;

    let { associations, islsp } = this.props;

    associations = associations.filter((item) => item.id !== user.id);

    const {
      filter_lsp,
      bfiles,
      page,
      total_pages,
      loading,
      filteredInfo,
    } = this.state;

    const handleTableChange = (_, filters, __) => {
      this.setState({ statusFilters: filters.status });
    };

    let direction = DESC;
    if ("ea_virtual_sorting_direction" in window.localStorage) {
      direction = window.localStorage.ea_virtual_sorting_direction;
    }

    let columns = [
      {
        title: (
          <div>
            <Translate text={`Customer Name`} />
          </div>
        ),
        dataIndex: "customer_name",
        key: "customer_name",
        width: 200,

        render(text, record) {
          return {
            props: {
              // style: { borderBottomColor: record.borderBottomColor },
            },
            children: (
              <div>
                <div className="autoHandleContentStyle">{text}</div>
              </div>
            ),
          };
        },
      },
      {
        title: (
          <div>
            <Translate text={`Calendar Time`} />
          </div>
        ),
        dataIndex: "calendar_time",
        key: "calendar_time",
        width: 200,

        sortOrder: direction === DESC ? SORT_ORDER_DESCEND : SORT_ORDER_ASCEND,
        onHeaderCell: () => {
          return {
            onClick: () => {
              if (direction === DESC) {
                // Virtual Follow-Up Appointments Scheduled - sorting direction
                window.localStorage.ea_virtual_sorting_direction = ASC;
              } else {
                // Virtual Follow-Up Appointments Scheduled - sorting direction
                window.localStorage.ea_virtual_sorting_direction = DESC;
              }
              this.setState({ loading: true }, () => this.loadBFiles(1));
            },
          };
        },
        sorter: true,
      },
      {
        title: (
          <div>
            <Translate text={`Agency Staff`} />
          </div>
        ),
        dataIndex: "lsp",
        key: "lsp",
        width: 200,

        render(text, record) {
          return {
            props: {
              // style: { borderBottomColor: record.borderBottomColor },
            },
            children: (
              <div>
                <div className="autoHandleContentStyle">{text}</div>
              </div>
            ),
          };
        },
      },
      {
        title: (
          <div>
            <Translate text={`Status`} />
          </div>
        ),
        dataIndex: "status",
        // uncomment the following filters on actual implementation
        filters: [
          {
            text: "Complete",
            value: "Complete",
          },
          {
            text: "Not Complete",
            value: "Not Complete",
          },
        ],
        // defaultFilteredValue: ["Complete", "Not Complete"],
        filteredValue: filteredInfo,
        // onFilter: (value, record) => record.name.includes(value),
        key: "status",
        width: 200,
        ellipsis: true,

        render(text, record) {
          return {
            props: {
              // style: { borderBottomColor: record.borderBottomColor },
            },
            children: (
              // uncomment the following code on actual implementation
              <div>
                <span
                  className="dot"
                  style={{ backgroundColor: record.borderBottomColor }}
                ></span>{" "}
                <span>{text}</span>
              </div>
              // <div style={{ textAlign: "center" }}>-</div>
            ),
          };
        },
      },
      {
        title: (
          <div>
            <Translate text={`Reschedule`} />
          </div>
        ),
        dataIndex: "Reschedule",
        key: "Reschedule",
        width: 200,
      }
    ];

    if ((this.state.type_of_call_selected === 'Review' && this.props.review) || (['Prospect', 'FollowUp'].includes(this.state.type_of_call_selected) && this.props.vonboard)) {
      columns.push({
        title: (
          <div>
            <Translate text={`Mark as Complete`} />
          </div>
        ),
        dataIndex: "mark_as_complete",
        key: "mark_as_complete",
        width: 200
      })
    }


    // if (bfiles.length > 0) {
    //   F.log("NOOR => bfiles Data =>", JSON.stringify(bfiles));
    // }

    const data = [];
    for (let i = 0; i < bfiles.length; i++) {
      const bfile = bfiles[i];

      // const isComplete =
      //   bfile.need_attention ||
      //   bfile.onboarding_id ||
      //   bfile.financial_id ||
      //   bfile.is_onboarded ||
      //   bfile.archive;
      const isComplete = F.isVonBorderBFileCompleted(bfile);
      const mark_as_complete_visible = (bfile.agency &&
        !isComplete) &&
        (['Review'].includes(this.state.type_of_call_selected)
          ? this.props.review ? true : false
          : ['Prospect', 'FollowUp'].includes(this.state.type_of_call_selected)
            ? this.props.vonboard ? true : false
            : false);


      const status = isComplete ? "Complete" : "Not Complete";
      let borderBottomColor = "#2dcc70";
      if (!isComplete) {
        // compare appointment time with current time => http://jsfiddle.net/e34y0p1v/
        var currentDateTime = moment(new Date()).utc(); // 09
        var appointmentDate = moment(
          new Date(F.getVonBorderAppointmentDateFromBFile(bfile))
        ).utc(); // 08
        var diffInHours = appointmentDate.diff(currentDateTime, "hours");

        // TRUE => UPCOMING , FALSE => TIME EXCEEDED
        const isUpcomingAppointment = diffInHours >= -12;

        if (isUpcomingAppointment) borderBottomColor = "#f1c40f";
        else borderBottomColor = "#e74c3d";
      }

      let Reschedule = !isComplete ? (
        <Button
          // style={{ marginLeft: 10 }}
          onClick={() => {
            this.setState({ loading: true });

            this.rescheduleAppointment(bfile);
          }}
          danger
        >
          <Translate text={`Reschedule`} />
        </Button>
      ) : (
        <span />
      );

      let mark_as_complete = mark_as_complete_visible ? (
        <Button
          // style={{ marginLeft: 10 }}
          onClick={() => {
            this.setState({ loading: true });

            this.mark_as_complete(bfile);
          }}
          danger
        >
          <Translate text={`Mark as Complete`} />
        </Button>
      ) : (
        <span />
      );

      // 2022-09-01T10:30:48-04:00
      const calendar_time = moment(
        F.getVonBorderAppointmentDateFromBFile(bfile)
      )
        // .utc()
        .format("MM/DD/YYYY hh:mmA");

      if (this.state.statusFilters.includes(status)) {
        data.push({
          customer_name: (
            <Link to={"/customer/" + bfile.id}>
              {bfile.first_name + " " + bfile.last_name}
            </Link>
          ),
          calendar_time,
          lsp: bfile.user.first_name + " " + bfile.user.last_name,
          status,
          Reschedule,
          isComplete,
          borderBottomColor,
          mark_as_complete
        });
      }
    }

    // let date_url = "";
    // if (period === "from_to") {
    //   date_url =
    //     "/all/" +
    //     encodeURIComponent(moment(start_date).format("MM/DD/YYYY")) +
    //     "/" +
    //     encodeURIComponent(moment(end_date).format("MM/DD/YYYY"));
    // }
    // if (period === "all_bfiles") {
    //   date_url = "?all_bfiles";
    // }

    // let totalPercentage = 0;
    // if (
    //   dashboard.agency_stats != null &&
    //   dashboard.agency_stats.completed_percentage != null
    // ) {
    //   totalPercentage = dashboard.agency_stats.completed_percentage;
    // }

    return (
      <div>
        <div>
          <Spin indicator={antIcon} spinning={loading}>
            <div style={{ marginBottom: 20 }}>
              {user.user_type !== "AGENCY_MANAGER" && data.length > 0 && (
                <Card
                  title={
                    <div>
                      <Icon
                        type="appstore"
                        style={{ marginRight: 10, color: "#1890ff" }}
                      />
                      <Translate
                        text={`${!islsp ? 'Virtual' : ""} Follow-Up Appointments Scheduled`}
                      />
                    </div>
                  }
                  bordered={false}
                  className="statsDetails have_extra"
                  extra={
                    // this.state.expandStats ? (
                    <Select
                      value={filter_lsp}
                      style={{ width: 200 }}
                      onChange={this.filterLSP}
                    >
                      <Option value="">
                        <Translate text={`Select Agent`} />
                        ...
                      </Option>
                      <Option value={user.id}>Me</Option>
                      {associations
                        .map((asso, i) => {
                          if (asso.user_type === "LSP") {
                            return (
                              <Option value={asso.id} key={i}>
                                {asso.first_name + " " + asso.last_name}
                              </Option>
                            );
                          } else {
                            return null;
                          }
                        })
                        .filter(Boolean)}
                    </Select>
                    // )
                    // : null
                  }
                // extra={
                //   <Select
                //     value={filter_lsp === user.email ? user.id : filter_lsp}
                //     style={{ width: 200 }}
                //     onChange={this.filterLSP}
                //   >
                //     <Option value="">
                //       <Translate text={`Select Agent`} />
                //       ...
                //     </Option>
                //     <Option value={user.id}>Me</Option>
                //     {associations
                //       .map((asso, i) => {
                //         if (asso.user_type === "LSP") {
                //           return (
                //             <Option value={asso.id} key={i}>
                //               {asso.first_name + " " + asso.last_name}
                //             </Option>
                //           );
                //         } else {
                //           return null;
                //         }
                //       })
                //       .filter(Boolean)}
                //   </Select>
                // }
                >
                  <Collapse expandStats={this.state.expandStats}>
                    <Table
                      // loading={loading}
                      columns={columns}
                      dataSource={data}
                      bordered={true}
                      pagination={false}
                      // onChange={handleTableChange}
                      onChange={this.handleChange}
                      expad
                      locale={{
                        filterConfirm: "OK",
                        filterReset: "",
                        // emptyText: <span>Loading...</span>,
                      }}
                    />
                    <Pagination
                      current_page={page}
                      total_pages={total_pages}
                      onClick={(page) => {
                        this.setState({ loading: true }, () =>
                          this.loadBFiles(page)
                        );
                      }}
                    />
                    {/* </div> */}
                  </Collapse>
                  {data.length > 0 && (
                    <ShowHideStats
                      expandStats={this.state.expandStats}
                      updateExpandState={this.updateExpandState}
                      applyParentDivOnShowStatsButton={true}
                    />
                  )}
                  {/* <Table
                  loading={loading}
                  columns={columns}
                  dataSource={data}
                  bordered={true}
                  pagination={false}
                  // onChange={handleTableChange}
                  onChange={this.handleChange}
                  expad
                  locale={{
                    filterConfirm: "OK",
                    filterReset: "",
                    // emptyText: <span>Loading...</span>,
                  }}
                />
                <Pagination
                  current_page={page}
                  total_pages={total_pages}
                  onClick={(page) => {
                    this.loadBFiles(page);
                  }}
                /> */}
                  {/* <SetupAppointment
                  history={this.props.history}
                  showModal={this.state.setup_appointment_modal}
                  hideModal={() =>
                    this.setState({ setup_appointment_modal: false })
                  }
                  // bfile={this.props}
                  user={user}
                  {...this.props}
                /> */}
                </Card>
              )}
            </div>
          </Spin>
        </div>
      </div>
    );
  }
}

export default VirtualOnboarderDataSentBackToAgency;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/ea/virtual-onboard-data-sent-back-to-agency.js